import { ApiError, apiRequest } from './client'
import type {
  ApiProduct,
  ApiProductDetail,
  ApiStorefrontCatalog,
  ProductKind,
  ProductStatus,
} from './types'

export function listProducts(params?: {
  status?: ProductStatus
  kind?: ProductKind
}): Promise<ApiProduct[]> {
  return apiRequest<ApiProduct[]>('/products', { query: params })
}

export function listStorefrontCatalog(coords?: {
  latitude?: number
  longitude?: number
}): Promise<ApiStorefrontCatalog> {
  return apiRequest<ApiStorefrontCatalog>('/products/storefront', { query: coords })
}

export function getProductById(id: string): Promise<ApiProductDetail> {
  return apiRequest<ApiProductDetail>(`/products/${id}`)
}

export async function getProductBySlug(slug: string): Promise<ApiProductDetail> {
  try {
    return await apiRequest<ApiProductDetail>(
      `/products/by-slug/${encodeURIComponent(slug)}`,
    )
  } catch (error) {
    if (!(error instanceof ApiError) || error.status !== 404) {
      throw error
    }
  }

  const products = await listProducts()
  const match = products.find((product) => product.slug === slug)
  if (!match) {
    throw new ApiError(`Product slug "${slug}" not found`, 404, null)
  }
  return getProductById(match.id)
}
